<template>
  <div class="page-wrapper">
    <div class="mb30">
      <h4>结算明细：</h4>
      <Table :columns="columns2" :data="data2"></Table>
    </div>
    <div class="mb30">
      <h4>费用项结算汇总：</h4>
      <div>
        <Row class="row">
          <Col span="4">费用项</Col>
          <Col span="5">应缴费用</Col>
          <Col span="5">已缴费用</Col>
          <Col span="5">应退费用</Col>
          <Col span="5">实退费用</Col>
        </Row>
        <Row class="row" v-for="(item,index) in data1" :key="'keyA'+index">
          <Col span="4">{{item.expenseItemName}}</Col>
          <Col span="5" class="textright"> {{item.receivableAmount?formatMoney(item.receivableAmount):(item.receivableAmount===0?0:'-')}}</Col>
          <Col span="5" class="textright">{{item.receivedAmount?formatMoney(item.receivedAmount):(item.receivedAmount===0?0:'-')}}</Col>
          <Col span="5" class="textright">{{item.refundAmount?formatMoney(item.refundAmount):(item.refundAmount===0?0:'-')}}</Col>
          <Col span="5" class="textright">{{item.actRefundAmount?formatMoney(item.actRefundAmount):(item.actRefundAmount===0?0:'-')}}</Col>
        </Row>
        <Row class="row">
          <Col span="4">合计</Col>
          <Col span="5" class="textright">{{formatMoney(receivableAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(receivedAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(refundAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(actRefundAmountSum)}}</Col>
        </Row>
      </div>
    </div>
    <div class="bold mb16">未核销账单汇总: {{selectBillTotal}} </div>
    <div class="mb30" style="font-weight: bold">
      <div class="inlineblock" style="margin-right: 50px">
        <span>付款方:</span>
        <span>{{actAddSelectBillTotal>0?'甲方':'乙方'}}</span>
      </div>
      <div class="inlineblock">
        <span>付款金额:</span>
        <span>{{formatMoney(Math.abs(actAddSelectBillTotal))}}</span>
      </div>
    </div>
    <div class="mb30" v-if="Number(actAddSelectBillTotal) !==0">
      <h4>{{actAddSelectBillTotal>0?'乙方储蓄账户信息':'甲方储蓄账户信息'}}</h4>
      <div>
        <Row class="row">
          <Col span="8">开户行名称</Col>
          <Col span="8">银行账号</Col>
          <Col span="8">开户人姓名</Col>
        </Row>

        <Row class="row">
          <Form :rules="formRules2" ref="countForm" :model="countParams">
            <Col span="8">
              <FormItem prop="bankName" class="notip textleft">
                <Select class="width80"
                        v-model="countParams.bankName"
                        :filterable="true" v-if="actAddSelectBillTotal>0"
                >
                  <Option value="">请选择</Option>
                  <Option v-for="(item,index) in bankList" :value="item.bankName" :key="'keyX'+item.bankCode">{{item.bankName}}</Option>
                </Select>
                <Input class="width80" v-model="countParams.bankName" v-if="actAddSelectBillTotal<=0"/>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="bankAccount" class="notip">
                <Input class="width80" v-model="countParams.bankAccount"/>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="accountName" class="notip">
                <Input class="width80" v-model="countParams.accountName"/>
              </FormItem>
            </Col>
          </Form>
        </Row>
      </div>
    </div>
    <h4>备注</h4>
    <Input style="width: 800px" type="textarea" v-model="countParams.costRemark"/>
    <div class="a1">
      <Button type="default" style="margin-right: 50px" @click.stop="toLast">上一步</Button>
      <!--      <Button type="primary" @click.stop="submit" :loading="loading">提交解约</Button>-->
      <!--      :loading="loading"-->
      <Button type="primary" @click.stop="submit" :loading="preLoading">预览解约协议</Button>

    </div>

    <settle-update :n="n" :dataOri="updateData"
                   v-if="updateData.length>0&&surBaseInfo"

                   :surFid="surFid"
                   @done="surrenderCalculatePriceDetail"
                   :nocancelSurFid="nocancelSurFid" :surBaseInfo="surBaseInfo"
    ></settle-update>
    <preview-protocal :n="preN"
                      :contractFid="contractFid"
                      @ok="epssubmit"></preview-protocal>
  </div>

</template>

<script>
  import SettleUpdate from './UpdateSettle'
  import {surrenderCalculatePrice, epssubmit} from "../../../../../api/contractList";
  import {surrenderCalculatePriceDetail,getBankInfo,updateEpsAccount} from "../../../../../api/contractList";
  import {formatMoney} from "../../../../../utils/format";
  import PreviewProtocal from '../../components/PreviewProtocal'


  export default {
    name: "SettleInfo",
    components: {
      SettleUpdate,
      PreviewProtocal
    },
    props: {
      n1: {
        type: Number,
        default: 0
      },
      surFid: {
        type: String,
        default: null
      },
      parentSurrenderFid: {
        type: String,
        default: null
      },
      stockStatus: [String, Number],
      stockRentDate: [String],
      surBaseInfo:{
        type:Object,
        default:null
      }
    },
    watch: {
      n1() {
        this.surrenderCalculatePrice()
      },

    },
    data() {
      return {
        preLoading:false,
        preN:0,
        nocancelSurFid:'',
        selectBillTotal:0,
        loading:false,
        surRentPriceDate: '',
        contractFid: '',
        countParams: {
          bankName: '',
          bankAccount: '',
          accountName: '',
          costRemark: ''
        },
        formRules2: {
          bankName: [
            {required: true, message: '', trigger: 'blur', type: 'string'}

          ],
          bankAccount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber}
          ],
          accountName: [
            {required: true, message: '', trigger: 'blur', type: 'string'}
          ]
        },
        n: 0,
        updateData: [],
        columns2: [
          {
            title: "房间号",
            key: "houseNumber",
            align: "center"
          },
          {
            title: "应缴总额",
            key: "receivableAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  textAlign:'right'
                }
              },formatMoney(params.row['receivableAmount']))
            }
          },
          {
            title: "已缴总额",
            key: "receivedAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  textAlign:'right'
                }
              },formatMoney(params.row['receivedAmount']))
            }
          },
          {
            title: "应退总额",
            key: "refundAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  textAlign:'right'
                }
              },formatMoney(params.row['refundAmount']))
            }

          },
          {
            title: "实退总额",
            key: "actRefundAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  textAlign:'right'
                }
              },formatMoney(params.row['actRefundAmount']))
            }
          },
          {
            title: "操作",
            key: "",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.updateData = params.row['surrenderBanlances']
                    this.nocancelSurFid=params.row['surrenderFid']
                    this.n++
                  }
                }
              }, '修改')
            }
          },
        ],
        data2: [],
        bankList:[]

      }
    },
    computed: {
      receivableAmountSum() {
        let ret = 0
        this.data1.forEach(ele => {
          ret += Number(ele.receivableAmount)
        })
        return ret.toFixed(2)
      },
      receivedAmountSum() {
        let ret = 0
        this.data1.forEach(ele => {
          ret += Number(ele.receivedAmount)
        })
        return ret.toFixed(2)
      },
      actRefundAmountSum() {
        let ret = 0
        this.data1.forEach(ele => {
          ret += Number(ele.actRefundAmount)
        })
        return ret.toFixed(2)
      },
      actAddSelectBillTotal(){
        return Number((Number(this.actRefundAmountSum)-this.selectBillTotal).toFixed(2))
      },


      refundAmountSum() {
        let ret = 0
        this.data1.forEach(ele => {
          ret += Number(ele.refundAmount)
        })
        return ret.toFixed(2)
      },
      data1() {
        let ret = []
        let transfer = {}
        for (let i = 0, len = this.data2.length; i < len; i++) {
          let list2 = this.data2[i].surrenderBanlances
          for (let j = 0, len2 = list2.length; j < len2; j++) {
            if (transfer[list2[j].itemCode]) {
              transfer[list2[j].itemCode].push(list2[j])
            }
            else {
              transfer[list2[j].itemCode] = [list2[j]]
            }
          }
        }
        // console.log(transfer)

        for (var i in transfer) {
          let receivableAmount = 0
          let receivedAmount = 0
          let refundAmount = 0
          let actRefundAmount = 0

          transfer[i].forEach(ele => {
            receivableAmount += Number(ele.receivableAmount)
            receivedAmount += Number(ele.receivedAmount)
            refundAmount += Number(ele.refundAmount)
            actRefundAmount += Number(ele.actRefundAmount)
          })
          ret.push({
            expenseItemName: transfer[i][0].expenseItemName,
            receivableAmount: receivableAmount.toFixed(2),
            receivedAmount: receivedAmount.toFixed(2),
            refundAmount: refundAmount.toFixed(2),
            actRefundAmount: actRefundAmount.toFixed(2)
          })
        }
        return ret
        // return [transfer]
      }
    },
    methods: {
      showProtocla(){
        this.preN++

      },
      formatMoney:formatMoney,
      epssubmit() {
        let params = {
          "accountName": this.countParams.accountName,
          "bankAccount": this.countParams.bankAccount,
          "bankName": this.countParams.bankName,
          "contractFid": this.contractFid,
          "costAmount": this.actRefundAmountSum,
          "costRemark": this.countParams.costRemark,
          "parentSurrenderFid": this.parentSurrenderFid,
          "payer": this.actAddSelectBillTotal >= 0 ? 0 : 1,   // 0-出租房 1-承租方  ,
          "stockStatus": this.stockStatus,
          stockRentDate: this.stockRentDate,
          "surrenderFid": this.surFid,
          "surRentPriceDate": this.surRentPriceDate,
          isUpdate:this.$route.query.fromreleases == 1?1:0,//0 不修改  1 修改
          actualCostAmount:this.actAddSelectBillTotal

        }
        this.loading = true
        epssubmit(params).then(res => {

          this.$Message.success('解约完成，签章后的解约协议，请到解约协议列表打印')
          if (this.$route.query.fromreleases == 1) {
            this.$router.push({
              name: 'order',
              query: {'fromupdate': 1},
              params:{targetTab:'3'}
            })
          }
          else {
            this.$router.push({
              name: 'order',
              params:{targetTab:'1'}

            })

          }

        }).finally(() => {
          this.loading = false
        })

      },
      submit() {
        let validate=true


        if(this.$refs['countForm']){
          this.$refs['countForm'].validate(bool => {
            if(!bool){
              this.$Message.info('请检查录入信息')
              validate=false
            }
          })
        }
        if(!validate){
          return
        }

        let params={
          "accountName": this.countParams.accountName,
          "bankAccount": this.countParams.bankAccount,
          "bankName": this.countParams.bankName,
          "contractFid": this.contractFid,
          "costAmount": this.actRefundAmountSum,
          "costRemark": this.countParams.costRemark,
          "parentSurrenderFid": this.parentSurrenderFid,
          "payer": this.actAddSelectBillTotal >= 0 ? 0 : 1,   // 0-出租房 1-承租方  ,
          "stockStatus": this.stockStatus,
          stockRentDate: this.stockRentDate,
          "surrenderFid": this.surFid,
          "surRentPriceDate": this.surRentPriceDate,
          isUpdate:this.$route.query.fromreleases == 1?1:0,//0 不修改  1 修改
          actualCostAmount:this.actAddSelectBillTotal

        }
        this.preLoading=true
        updateEpsAccount(params).then(res=>{
          this.preN++
        }).catch(error=>{

        }).finally(()=>{
          this.preLoading=false
        })

        // else {
        //   this.preN++
        //   // this.epssubmit()
        //
        // }




      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      surrenderCalculatePriceDetail() {
        let params = {
          surrenderIds: this.surFid
        }
        surrenderCalculatePriceDetail(params).then(res => {
          if(!res.data){
            return
          }
          res.data.surrenderCostItemList && (this.data2 = res.data.surrenderCostItemList)
          this.selectBillTotal=Number(res.data.selectBillTotal)

        }).catch(error => {
        })
      },

      surrenderCalculatePrice() {
        let params = {
          surrenderIds: this.surFid
        }
        surrenderCalculatePrice(params).then(res => {
          if (!res.data) {
            return
          }
          res.data.surrenderCostItemList &&    (this.data2 = res.data.surrenderCostItemList)
          this.data2[0] && (this.surRentPriceDate = this.data2[0].surrenderDate)
          this.selectBillTotal=Number(res.data.selectBillTotal)
        }).catch(error => {
        })

      },
      toLast() {
        this.$emit('tolast')
      }
    },
    created() {
      this.contractFid = this.$route.params.id
      getBankInfo().then(res=>{
        if(res.data) {
          this.bankList = res.data
        }
      }).catch(err=>{})

    },
  }
</script>

<style scoped>
  .textright{
    text-align: right;
  }
  .width80 {
    width: 80%;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  h4 {
    margin-bottom: 10px;
  }

  .mb30 {
    margin-bottom: 30px;
    width: 80%;
  }

  .inlineblock {
    display: inline-block;
  }

  .a1 {
    text-align: center;
    margin-top: 30px;
  }

</style>
